<div class="new-leadType-five" fxLayout="column" fxFlex>

    <div class="lead-detail-page" fxLayout="column" fxFlex>

        <div class="header-container" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="10px" fxHide.lt-md
            fxHide.md>


            <button [attr.guide]="'lead-detail-panel-btn-16' + '__' + sanitizedUrl" class="header-btn"
                (click)="goPrevious()" matTooltip="Previous"
                [disabled]="isNavigatingPrev || isNavigatingNext || !allIds?.length || currentIndex <= 0">
                <mat-spinner *ngIf="isNavigatingPrev" diameter="16"
                    style="vertical-align: middle; margin-right: 4px; display: inline-block;"></mat-spinner>
                <mat-icon *ngIf="!isNavigatingPrev"
                    style="font-size: 18px; width: 18px; height: 18px; vertical-align: middle; margin-right: 2px;">chevron_left</mat-icon>
                Previous</button>
            <button [attr.guide]="'lead-detail-panel-btn-17' + '__' + sanitizedUrl" class="header-btn"
                (click)="goNext()" matTooltip="Next"
                [disabled]="isNavigatingPrev || isNavigatingNext || !allIds?.length || currentIndex >= allIds.length - 1">
                <mat-spinner *ngIf="isNavigatingNext" diameter="16"
                    style="vertical-align: middle; margin-right: 4px; display: inline-block;"></mat-spinner>
                <mat-icon *ngIf="!isNavigatingNext"
                    style="font-size: 18px; width: 18px; height: 18px; vertical-align: middle; margin-right: 2px;">chevron_right</mat-icon>
                Next</button>

            <button [attr.guide]="'lead-detail-btn-171' + '__' + sanitizedUrl" type="button" class="header-btn"
                [matMenuTriggerFor]="actionsMenu" (click)="$event.stopPropagation()">
                <span class="material-symbols-outlined">more_vert</span>
            </button>
            <button [attr.guide]="'lead-detail-btn-158' + '__' + sanitizedUrl" class="header-btn" (click)="back()">
                <mat-icon
                    style="font-size: 18px; width: 18px; height: 18px; vertical-align: middle; margin-right: 2px;">close</mat-icon>
            </button>
            <mat-menu #actionsMenu="matMenu" yPosition="below" xPosition="before">
                <button [attr.guide]="'lead-detail-btn-172' + '__' + sanitizedUrl"
                    [disabled]="!resourcePrivilege?.update"
                    (click)="editProduct(DealDetailsObject.entityId,DealDetailsObject.attributeSetId)" mat-menu-item>
                    <span class="material-symbols-outlined"
                        style="font-size: 20px;line-height: 1;vertical-align: sub;padding-right: 5px;">edit</span>
                    <span>Edit</span>
                </button>

                <button [attr.guide]="'lead-detail-btn-173' + '__' + sanitizedUrl"
                    [disabled]="!resourcePrivilege?.delete" (click)="deleteAllProductId(DealDetailsObject.entityId)"
                    mat-menu-item>
                    <span class="material-symbols-outlined new-menu"
                        style="font-size: 20px;line-height: 1;vertical-align: sub;padding-right: 5px;">delete</span>
                    <span>Delete</span>
                </button>
            </mat-menu>
        </div>

        <div class="header-container" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px" fxHide fxShow.lt-lg>
            <div class="mobile-actions header-actions-compact" fxLayout="row" fxLayoutAlign="end center"
                fxLayoutGap="8px">


                <button [attr.guide]="'lead-detail-panel-btn-16' + '__' + sanitizedUrl" class="header-btn"
                    (click)="goPrevious()" matTooltip="Previous"
                    [disabled]="isNavigatingPrev || isNavigatingNext || !allIds?.length || currentIndex <= 0">
                    <mat-spinner *ngIf="isNavigatingPrev" diameter="16"
                        style="vertical-align: middle; margin-right: 4px; display: inline-block;"></mat-spinner>
                    <mat-icon *ngIf="!isNavigatingPrev"
                        style="font-size: 18px; width: 18px; height: 18px; vertical-align: middle; margin-right: 2px;">chevron_left</mat-icon>
                    Previous</button>
                <button [attr.guide]="'lead-detail-panel-btn-17' + '__' + sanitizedUrl" class="header-btn"
                    (click)="goNext()" matTooltip="Next"
                    [disabled]="isNavigatingPrev || isNavigatingNext || !allIds?.length || currentIndex >= allIds.length - 1">
                    <mat-spinner *ngIf="isNavigatingNext" diameter="16"
                        style="vertical-align: middle; margin-right: 4px; display: inline-block;"></mat-spinner>
                    <mat-icon *ngIf="!isNavigatingNext"
                        style="font-size: 18px; width: 18px; height: 18px; vertical-align: middle; margin-right: 2px;">chevron_right</mat-icon>
                    Next</button>

                <button [attr.guide]="'lead-detail-btn-edit-or-delete' + '__' + sanitizedUrl" mat-icon-button
                    class="action-icon" [matMenuTriggerFor]="editDeleteMenu" aria-label="Edit or Delete">
                    <mat-icon>more_vert</mat-icon>
                </button>
                <button [attr.guide]="'lead-detail-btn-158' + '__' + sanitizedUrl" class="header-btn" (click)="back()">
                    <mat-icon
                        style="font-size: 18px; width: 18px; height: 18px; vertical-align: middle; margin-right: 2px;">close</mat-icon>
                </button>
            </div>

            <mat-menu #editDeleteMenu="matMenu" yPosition="below" xPosition="before">
                <button [attr.guide]="'lead-detail-btn-175' + '__' + sanitizedUrl"
                    [disabled]="!resourcePrivilege?.update"
                    (click)="editProduct(DealDetailsObject.entityId,DealDetailsObject.attributeSetId)" mat-menu-item>
                    <span class="material-symbols-outlined"
                        style="font-size: 20px;line-height: 1;vertical-align: sub;padding-right: 5px;">edit</span>
                    <span>Edit</span>
                </button>

                <button [attr.guide]="'lead-detail-btn-176' + '__' + sanitizedUrl"
                    [disabled]="!resourcePrivilege?.delete" (click)="deleteAllProductId(DealDetailsObject.entityId)"
                    mat-menu-item>
                    <span class="material-symbols-outlined new-menu"
                        style="font-size: 20px;line-height: 1;vertical-align: sub;padding-right: 5px;">delete</span>
                    <span>Delete</span>
                </button>
            </mat-menu>
        </div>

        <div class="main-content-wrapper" fxLayout="row" fxLayout.lt-md="column" fxFlex>

            <div class="left-sidebar" fxFlex="22" fxFlex.lt-md="100" fxLayout="column" fxLayoutGap="10px">
                <div class="profile-card">
                    <div class="profile-header" fxLayout="column" fxLayoutGap="10px">
                        <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
                            <div class="avatar-container">
                                <div class="avatar-initial">
                                    {{ DealDetailsObject?.dealsName?.slice(0, 2) | uppercase }}
                                </div>
                            </div>
                            <div class="overlay-details" style="min-width: 0; overflow: hidden;">
                                <div class="name-row"
                                    style="display:flex;align-items:center;gap:8px;min-width: 0;overflow: hidden;">
                                    <h2 class="name"
                                        style="margin:0; flex: 1; min-width: 0; white-space: normal; word-break: break-word; line-height: 1.4;">
                                        {{ (DealDetailsObject?.name?.indexOf(' ') === -1
                                        && DealDetailsObject?.name?.length > 20) ? (DealDetailsObject?.name |
                                        slice:0:20) + '...' : DealDetailsObject?.name }}</h2>
                                </div>
                            </div>
                        </div>

                        <div class="profile-info">

                            <!-- Deal Name -->
                            <div class="flex items-center">
                                <p class="title items-center gap-2"
                                    [style.cursor]="DealDetailsObject?.dealsName || DealDetailsObject?.dealname ? 'pointer' : 'not-allowed'"
                                    [style.pointerEvents]="!(DealDetailsObject?.dealsName || DealDetailsObject?.dealname) ? 'none' : 'auto'"
                                    [style.opacity]="!(DealDetailsObject?.dealsName || DealDetailsObject?.dealname) ? '0.6' : '1'">
                                    <mat-icon style="font-size: 16px; padding-top: 10px;" class="primary-icon">
                                        local_offer
                                    </mat-icon>
                                    <span>
                                        {{ DealDetailsObject?.dealsName || DealDetailsObject?.dealname || '---' }}
                                    </span>
                                </p>
                                <!-- <button class="edit-btn title" style="opacity: 1; margin-left: 10px;"
                                    (click)="openEditPopup('dealsName', 'Deals Name', 'text'); $event.stopPropagation()">
                                    <mat-icon style="font-size: 16px; padding-top: 10px;">edit</mat-icon>
                                </button> -->
                            </div>

                            <!-- Deal Stage -->
                            <div class="flex items-center">
                                <p class="title items-center gap-2"
                                    [style.cursor]="DealDetailsObject?.statusName || DealDetailsObject?.stage ? 'pointer' : 'not-allowed'"
                                    [style.pointerEvents]="!(DealDetailsObject?.statusName || DealDetailsObject?.stage) ? 'none' : 'auto'"
                                    [style.opacity]="!(DealDetailsObject?.statusName || DealDetailsObject?.stage) ? '0.6' : '1'">
                                    <mat-icon style="font-size: 16px; padding-top: 10px;" class="primary-icon">
                                        info
                                    </mat-icon>
                                    <span>
                                        {{ DealDetailsObject?.statusName || DealDetailsObject?.stage || '---' }}
                                    </span>
                                </p>
                                <!-- <button class="edit-btn title" style="opacity: 1; margin-left: 10px;"
                                    (click)="openEditPopup('statusName', 'Stage', 'select'); $event.stopPropagation()">
                                    <mat-icon style="font-size: 16px; padding-top: 10px;">edit</mat-icon>
                                </button> -->
                            </div>

                            <!-- Owner -->
                            <div class="flex items-center">
                                <p class="title items-center gap-2"
                                    [style.cursor]="DealDetailsObject?.ownerIdName ? 'pointer' : 'not-allowed'"
                                    [style.pointerEvents]="!DealDetailsObject?.ownerIdName ? 'none' : 'auto'"
                                    [style.opacity]="!DealDetailsObject?.ownerIdName ? '0.6' : '1'">
                                    <mat-icon style="font-size: 16px; padding-top: 10px;" class="primary-icon">
                                        attribution
                                    </mat-icon>
                                    <span>
                                        {{ DealDetailsObject?.ownerIdName ? (DealDetailsObject.ownerIdName.split('@')[0]
                                        | titlecase) : '---' }}
                                    </span>
                                </p>
                                <!-- <button class="edit-btn title" style="opacity: 1; margin-left: 10px;"
                                    (click)="transferLead(); $event.stopPropagation()">
                                    <mat-icon style="font-size: 16px; padding-top: 10px;">edit</mat-icon>
                                </button> -->
                            </div>

                            <!-- Payment Status -->
                            <div class="flex items-center">
                                <p class="title items-center gap-2"
                                    [style.cursor]="DealDetailsObject?.paymentStatus ? 'pointer' : 'not-allowed'"
                                    [style.pointerEvents]="!DealDetailsObject?.paymentStatus ? 'none' : 'auto'"
                                    [style.opacity]="!DealDetailsObject?.paymentStatus ? '0.6' : '1'">
                                    <mat-icon style="font-size: 16px; padding-top: 10px;" class="primary-icon">
                                        payments
                                    </mat-icon>
                                    <span>
                                        {{ DealDetailsObject?.paymentStatus || '---' }}
                                    </span>
                                </p>
                                <!-- <button class="edit-btn title" style="opacity: 1; margin-left: 10px;"
                                    (click)="openEditPopup('paymentStatus', 'Payment Status', 'select'); $event.stopPropagation()">
                                    <mat-icon style="font-size: 16px; padding-top: 10px;">edit</mat-icon>
                                </button> -->
                            </div>

                            <!-- Paid -->
                            <div class="flex items-center">
                                <p class="title items-center gap-2"
                                    [style.cursor]="DealDetailsObject?.paid ? 'pointer' : 'not-allowed'"
                                    [style.pointerEvents]="!DealDetailsObject?.paid ? 'none' : 'auto'"
                                    [style.opacity]="!DealDetailsObject?.paid ? '0.6' : '1'">
                                    <mat-icon style="font-size: 16px; padding-top: 10px;" class="primary-icon">
                                        attach_money
                                    </mat-icon>
                                    <span>
                                        {{ DealDetailsObject?.paid || '---' }}
                                    </span>
                                </p>
                                <!-- <button class="edit-btn title" style="opacity: 1; margin-left: 10px;"
                                    (click)="openEditPopup('paid', 'Paid', 'number'); $event.stopPropagation()">
                                    <mat-icon style="font-size: 16px; padding-top: 10px;">edit</mat-icon>
                                </button> -->
                            </div>

                            <!-- Balance -->
                            <div class="flex items-center">
                                <p class="title items-center gap-2"
                                    [style.cursor]="DealDetailsObject?.balance ? 'pointer' : 'not-allowed'"
                                    [style.pointerEvents]="!DealDetailsObject?.balance ? 'none' : 'auto'"
                                    [style.opacity]="!DealDetailsObject?.balance ? '0.6' : '1'">
                                    <mat-icon style="font-size: 16px; padding-top: 10px;" class="primary-icon">
                                        account_balance_wallet
                                    </mat-icon>
                                    <span>
                                        {{ DealDetailsObject?.balance || '---' }}
                                    </span>
                                </p>
                                <!-- <button class="edit-btn title" style="opacity: 1; margin-left: 10px;"
                                    (click)="openEditPopup('balance', 'Balance', 'number'); $event.stopPropagation()">
                                    <mat-icon style="font-size: 16px; padding-top: 10px;">edit</mat-icon>
                                </button> -->
                            </div>

                        </div>
                    </div>
                </div>


            </div>

            <div class="right-content-area" fxLayout="column" fxFlex="78" fxFlex.lt-md="100">
                <nav class="top-navigation">
                    <ul>
                        <li *ngFor="let tab of tabs" (click)="setActiveTab(tab.name)"
                            [class.active]="activeTab === tab.name">
                            <span class="material-symbols-outlined icon">{{ tab.icon }}</span>
                            <span class="tab-name">{{ tab.name }}</span>
                        </li>
                    </ul>
                </nav>
                <div [ngSwitch]="activeTab" class="dynamic-content" style="width: 100%;">
                    <div *ngSwitchCase="'Overview'" class="overview">
                        <!-- 
  This container holds the entire overview screen.
  It's structured with a main content area on the left and a notes section on the right.
  This layout stacks vertically on smaller screens for responsiveness.
-->
                        <div class="overview-cont">
                            <header class="overview-header">
                                <h1 class="title">Overview</h1>
                                <!-- <button [attr.guide]="'lead-detail-btn-198' + '__' + sanitizedUrl" class="customize-btn">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="icon" fill="none" viewBox="0 0 24 24"
                                        stroke="currentColor" stroke-width="2">
                                        <path stroke-linecap="round" stroke-linejoin="round"
                                            d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                                        <path stroke-linecap="round" stroke-linejoin="round"
                                            d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                    </svg>
                                    Customize overview
                                </button> -->

                                <!-- <mat-form-field>
                                    <input [attr.guide]="'lead-detail-inp-199' + '__' + sanitizedUrl" matInput
                                        placeholder="Search..." [(ngModel)]="globalSearchText"
                                        (keydown.enter)="onGlobalSearchChange(globalSearchText)"
                                        (keydown.backspace)="onGlobalSearchBackspace($event)" />
                                    <button [attr.guide]="'lead-detail-btn-clear-search' + '__' + sanitizedUrl"
                                        mat-icon-button matSuffix *ngIf="globalSearchText" aria-label="Clear search"
                                        (click)="resetSearch()"
                                        style="height:28px;width:28px;min-width:28px;padding:0;">
                                        <mat-icon style="font-size:16px;line-height:28px;">close</mat-icon>
                                    </button>
                                </mat-form-field> -->

                            </header>

                            <!-- Lifecycle and Status Pipeline Section -->
                            <section *ngIf="!isSearching" class="pipeline-section">

                                <div class="status-pipeline-wrapper">
                                    <label>Status</label>
                                    <div class="status-pipeline">
                                        <div *ngIf="!filtereddropdownTypeList || filtereddropdownTypeList.length === 0" style="display: flex; align-items: center; gap: 8px; padding: 10px 14px; color: #8898aa; font-size: 13px;">
                                            <mat-spinner diameter="18"></mat-spinner>
                                            <span>Loading stages...</span>
                                        </div>
                                        <div *ngFor="let step of filtereddropdownTypeList; let i = index"
                                            class="strip-stage" [ngClass]="{
          'stage-current': (currentStatusIndex === i) || step.statusName === (DealDetailsObject?.stage || DealDetailsObject?.dealStage || DealDetailsObject?.statusName),
          'stage-completed': i <= currentStatusIndex,
          'last-stage': i === filtereddropdownTypeList.length - 1
        }" [attr.data-toggle]="'tooltip'" [attr.data-html]="'true'" [attr.data-container]="'body'"
                                            [attr.title]="generateTooltip(step)"
                                            (click)="updateLeadStatusNew($event,step)">
                                            <span>{{ step.statusName }}</span>
                                        </div>
                                    </div>



                                </div>
                            </section>


                            <!-- After-Sales Pipeline Section (reusable component) -->
                            <section *ngIf="!isSearching" class="pipeline-section after-sales-section">
                                <app-after-sales-pipeline-tracker
                                      [entityObject]="DealDetailsObject"
                                      [entityType]="'deal'"
                                      [dealStages]="filtereddropdownTypeList"
                                      (statusUpdated)="getAllLeadDetails(DealDetailsObject.entityId)"
                                      (advanceDealStage)="updateLeadStatusFromPopup($event)">
                                </app-after-sales-pipeline-tracker>
                            </section>
                        </div>


                        <div *ngIf="!isSearching" class="overview-container">

                            <!-- Main Content Section (Left) -->
                            <main class="main-content-two" fxFlex="100">
                                <!-- Header: Title and Customize Button -->

                                <!-- Summary Section (Collapsible) -->
                                <!-- <section class="summary-section" fxLayout="row">
                                    <div class="summary-header">
                                        <div class="summary-title">
                                            <svg xmlns="http://www.w3.org/2000/svg" class="icon" fill="none"
                                                viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                                <path stroke-linecap="round" stroke-linejoin="round"
                                                    d="M13 10V3L4 14h7v7l9-11h-7z" />
                                            </svg>
                                            <span>Summary</span>
                                        </div>
                                        <svg xmlns="http://www.w3.org/2000/svg" class="dropdown-icon" fill="none"
                                            viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
                                        </svg>
                                    </div>
                                </section> -->

                                <!---->
                                <div class="contact-details-container">
                                    <div class="details-header">

                                    </div>

                                    <div class="details-content">
                                        <div class="content-section">
                                            <div class="section-body">
                                                <div class="details-grid-4col"
                                                    style="grid-template-columns: repeat(2, 1fr);">

                                                    <div class="info-item"
                                                        *ngIf="DealDetailsObject?.dealsName || DealDetailsObject?.dealname">
                                                        <label>Deals Name</label>
                                                        <div class="value-display">
                                                            <a>{{ DealDetailsObject?.dealsName ||
                                                                DealDetailsObject?.dealname }}</a>
                                                            <!-- <button
                                                                [attr.guide]="'lead-detail-btn-custom-1' + '__' + sanitizedUrl"
                                                                (click)="openEditPopup('dealsName', 'Deals Name', 'text')"
                                                                class="edit-btn">
                                                                <mat-icon>edit</mat-icon>
                                                            </button> -->
                                                        </div>
                                                    </div>

                                                    <div class="info-item"
                                                        *ngIf="DealDetailsObject?.product && DealDetailsObject?.product !== '-'">
                                                        <label>Product</label>
                                                        <div class="value-display">
                                                            <a>{{ DealDetailsObject?.product }}</a>
                                                            <!-- <button
                                                                [attr.guide]="'lead-detail-btn-custom-2' + '__' + sanitizedUrl"
                                                                (click)="openEditPopup('product', 'Product', 'text')"
                                                                class="edit-btn">
                                                                <mat-icon>edit</mat-icon>
                                                            </button> -->
                                                        </div>
                                                    </div>

                                                    <div class="info-item"
                                                        *ngIf="DealDetailsObject?.amount != null && DealDetailsObject?.amount !== ''">
                                                        <label>Amount</label>
                                                        <div class="value-display">
                                                            <a>{{ DealDetailsObject?.amount }}</a>
                                                            <!-- <button
                                                                [attr.guide]="'lead-detail-btn-custom-3' + '__' + sanitizedUrl"
                                                                (click)="openEditPopup('amount', 'Amount', 'number')"
                                                                class="edit-btn">
                                                                <mat-icon>edit</mat-icon>
                                                            </button> -->
                                                        </div>
                                                    </div>

                                                    <div class="info-item"
                                                        *ngIf="DealDetailsObject?.statusName || DealDetailsObject?.stage">
                                                        <label>Stage</label>
                                                        <div class="value-display">
                                                            <a>{{ DealDetailsObject?.statusName ||
                                                                DealDetailsObject?.stage
                                                                }}</a>
                                                            <!-- <button
                                                                [attr.guide]="'lead-detail-btn-custom-4' + '__' + sanitizedUrl"
                                                                (click)="openEditPopup('statusName', 'Stage', 'select')"
                                                                class="edit-btn">
                                                                <mat-icon>edit</mat-icon>
                                                            </button> -->
                                                        </div>
                                                    </div>

                                                    <div class="info-item"
                                                        *ngIf="DealDetailsObject?.ownerIdName && DealDetailsObject?.ownerIdName !== '-'">
                                                        <label>Deals Owner</label>
                                                        <div class="value-display">
                                                            <a>{{ (DealDetailsObject?.ownerIdName || '').split('@')[0] |
                                                                titlecase }}</a>
                                                            <!-- <button
                                                                [attr.guide]="'lead-detail-btn-custom-5' + '__' + sanitizedUrl"
                                                                (click)="transferLead()" class="edit-btn">
                                                                <mat-icon>edit</mat-icon>
                                                            </button> -->
                                                        </div>
                                                    </div>

                                                    <div class="info-item" *ngIf="DealDetailsObject?.closingDate">
                                                        <label>Closing Date</label>
                                                        <div class="value-display">
                                                            <a>{{ DealDetailsObject?.closingDate | date:'mediumDate'
                                                                }}</a>
                                                            <!-- <button
                                                                [attr.guide]="'lead-detail-btn-custom-6' + '__' + sanitizedUrl"
                                                                (click)="openEditPopup('closingDate', 'Closing Date', 'date')"
                                                                class="edit-btn">
                                                                <mat-icon>edit</mat-icon>
                                                            </button> -->
                                                        </div>
                                                    </div>

                                                    <div class="info-item"
                                                        *ngIf="DealDetailsObject?.expectedClosingDate">
                                                        <label>Expected Closing Date</label>
                                                        <div class="value-display">
                                                            <a>{{ DealDetailsObject?.expectedClosingDate |
                                                                date:'mediumDate'
                                                                }}</a>
                                                            <!-- <button
                                                                [attr.guide]="'lead-detail-btn-custom-7' + '__' + sanitizedUrl"
                                                                (click)="openEditPopup('expectedClosingDate', 'Expected Closing Date', 'date')"
                                                                class="edit-btn">
                                                                <mat-icon>edit</mat-icon>
                                                            </button> -->
                                                        </div>
                                                    </div>

                                                    <div class="info-item" *ngIf="DealDetailsObject?.leadCreatedDate">
                                                        <label>Lead Created Date</label>
                                                        <div class="value-display">
                                                            <a>{{ DealDetailsObject?.leadCreatedDate | date:'mediumDate'
                                                                }}</a>
                                                            <!-- <button
                                                                [attr.guide]="'lead-detail-btn-custom-8' + '__' + sanitizedUrl"
                                                                (click)="openEditPopup('leadCreatedDate', 'Lead Created Date', 'date')"
                                                                class="edit-btn">
                                                                <mat-icon>edit</mat-icon>
                                                            </button> -->
                                                        </div>
                                                    </div>

                                                    <div class="info-item"
                                                        *ngIf="DealDetailsObject?.name && DealDetailsObject?.name !== '-'">
                                                        <label>Lead Name</label>
                                                        <div class="value-display">
                                                            <a>{{ (DealDetailsObject?.name?.indexOf(' ') === -1 &&
                                                                DealDetailsObject?.name?.length > 20) ?
                                                                (DealDetailsObject?.name | slice:0:20) + '...' :
                                                                DealDetailsObject?.name }}</a>
                                                            <!-- <button
                                                                [attr.guide]="'lead-detail-btn-custom-9' + '__' + sanitizedUrl"
                                                                (click)="openEditPopup('name', 'Lead Name', 'text')"
                                                                class="edit-btn">
                                                                <mat-icon>edit</mat-icon>
                                                            </button> -->
                                                        </div>
                                                    </div>

                                                    <div class="info-item"
                                                        *ngIf="DealDetailsObject?.company && DealDetailsObject?.company !== '-'">
                                                        <label>Company</label>
                                                        <div class="value-display">
                                                            <a (click)="goToCompany()">{{ DealDetailsObject?.company
                                                                }}</a>
                                                            <!-- <button
                                                                [attr.guide]="'lead-detail-btn-custom-10' + '__' + sanitizedUrl"
                                                                (click)="openEditPopup('company', 'Company', 'text')"
                                                                class="edit-btn">
                                                                <mat-icon>edit</mat-icon>
                                                            </button> -->
                                                        </div>
                                                    </div>

                                                    <div class="info-item" *ngIf="DealDetailsObject?.createdDate">
                                                        <label>Created Date</label>
                                                        <div class="value-display">
                                                            <a>{{ DealDetailsObject?.createdDate | date:'mediumDate'
                                                                }}</a>
                                                            <!-- <button
                                                                [attr.guide]="'lead-detail-btn-custom-11' + '__' + sanitizedUrl"
                                                                (click)="openEditPopup('createdDate', 'Created Date', 'date')"
                                                                class="edit-btn">
                                                                <mat-icon>edit</mat-icon>
                                                            </button> -->
                                                        </div>
                                                    </div>

                                                    <div class="info-item" *ngIf="DealDetailsObject?.updatedDate">
                                                        <label>Updated Date</label>
                                                        <div class="value-display">
                                                            <a>{{ DealDetailsObject?.updatedDate | date:'mediumDate'
                                                                }}</a>
                                                            <!-- <button
                                                                [attr.guide]="'lead-detail-btn-custom-12' + '__' + sanitizedUrl"
                                                                (click)="openEditPopup('updatedDate', 'Updated Date', 'date')"
                                                                class="edit-btn">
                                                                <mat-icon>edit</mat-icon>
                                                            </button> -->
                                                        </div>
                                                    </div>

                                                    <div class="info-item"
                                                        *ngIf="DealDetailsObject?.reasonForLoss && DealDetailsObject?.reasonForLoss !== '-'">
                                                        <label>Reason For Loss</label>
                                                        <div class="value-display">
                                                            <a>{{ DealDetailsObject?.reasonForLoss }}</a>
                                                            <!-- <button
                                                                [attr.guide]="'lead-detail-btn-custom-13' + '__' + sanitizedUrl"
                                                                (click)="openEditPopup('reasonForLoss', 'Reason For Loss', 'text')"
                                                                class="edit-btn">
                                                                <mat-icon>edit</mat-icon>
                                                            </button> -->
                                                        </div>
                                                    </div>

                                                    <div class="info-item" *ngIf="DealDetailsObject?.renewalDate">
                                                        <label>Renewal Date</label>
                                                        <div class="value-display">
                                                            <a>{{ DealDetailsObject?.renewalDate | date:'mediumDate'
                                                                }}</a>
                                                            <!-- <button
                                                                [attr.guide]="'lead-detail-btn-custom-14' + '__' + sanitizedUrl"
                                                                (click)="openEditPopup('renewalDate', 'Renewal Date', 'date')"
                                                                class="edit-btn">
                                                                <mat-icon>edit</mat-icon>
                                                            </button> -->
                                                        </div>
                                                    </div>

                                                    <div class="info-item"
                                                        *ngIf="DealDetailsObject?.probability != null && DealDetailsObject?.probability !== ''">
                                                        <label>Probability</label>
                                                        <div class="value-display">
                                                            <a>{{ DealDetailsObject?.probability }}</a>
                                                            <!-- <button
                                                                [attr.guide]="'lead-detail-btn-custom-15' + '__' + sanitizedUrl"
                                                                (click)="openEditPopup('probability', 'Probability', 'number')"
                                                                class="edit-btn">
                                                                <mat-icon>edit</mat-icon>
                                                            </button> -->
                                                        </div>
                                                    </div>

                                                    <div class="info-item"
                                                        *ngIf="DealDetailsObject?.paid != null && DealDetailsObject?.paid !== ''">
                                                        <label>Paid</label>
                                                        <div class="value-display">
                                                            <a>{{ DealDetailsObject?.paid }}</a>
                                                            <!-- <button
                                                                [attr.guide]="'lead-detail-btn-custom-16' + '__' + sanitizedUrl"
                                                                (click)="openEditPopup('paid', 'Paid', 'number')"
                                                                class="edit-btn">
                                                                <mat-icon>edit</mat-icon>
                                                            </button> -->
                                                        </div>
                                                    </div>

                                                    <div class="info-item"
                                                        *ngIf="DealDetailsObject?.balance != null && DealDetailsObject?.balance !== ''">
                                                        <label>Balance</label>
                                                        <div class="value-display">
                                                            <a>{{ DealDetailsObject?.balance }}</a>
                                                            <!-- <button
                                                                [attr.guide]="'lead-detail-btn-custom-17' + '__' + sanitizedUrl"
                                                                (click)="openEditPopup('balance', 'Balance', 'number')"
                                                                class="edit-btn">
                                                                <mat-icon>edit</mat-icon>
                                                            </button> -->
                                                        </div>
                                                    </div>

                                                    <div class="info-item"
                                                        *ngIf="DealDetailsObject?.paymentStatus && DealDetailsObject?.paymentStatus !== '-'">
                                                        <label>Payment Status</label>
                                                        <div class="value-display">
                                                            <a>{{ DealDetailsObject?.paymentStatus }}</a>
                                                            <!-- <button
                                                                [attr.guide]="'lead-detail-btn-custom-18' + '__' + sanitizedUrl"
                                                                (click)="openEditPopup('paymentStatus', 'Payment Status', 'select')"
                                                                class="edit-btn">
                                                                <mat-icon>edit</mat-icon>
                                                            </button> -->
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </main>



                        </div>

                        <div *ngIf="isSearching">

                            <calsoft-views [searchText]="globalSearchText" [leadPropertiesName]="leadPropertiesName"
                                [leadPropertiesDisplay]="leadPropertiesDisplay" [DealDetailsObject]="DealDetailsObject"
                                [leadAdditionalPropertiesDisplay]="leadAdditionalPropertiesDisplay"
                                [leadAdditionalPropertiesName]="leadAdditionalPropertiesName" [valuesList]="filterList"
                                [additionalSpec]="additionalSpec"
                                [leadCommonPropertiesDisplay]="leadCommonPropertiesDisplay" [usedInSite]="usedInSite"
                                [type3]="type3" [leadCommonPropertiesName]="leadCommonPropertiesName"
                                [activeViewNew]="activeViewNew"></calsoft-views>
                        </div>


                    </div>

                    <div *ngSwitchCase="'Contact details'">
                        <div class="contact-details-container">
                            <div class="details-header">
                                <h2>Contact details</h2>
                                <!-- <div class="header-actions">
                                    <button [attr.guide]="'lead-detail-btn-217' + '__' + sanitizedUrl" class="btn-secondary">View field edit history</button>
                                    <button [attr.guide]="'lead-detail-btn-218' + '__' + sanitizedUrl" class="btn-secondary">Manage fields</button>
                                </div> -->
                            </div>

                            <div class="details-tabs">
                                <button [attr.guide]="'lead-detail-btn-219' + '__' + sanitizedUrl"
                                    [class.active]="activeView === 'all'" (click)="setView('all')">All
                                    details</button>
                                <button [attr.guide]="'lead-detail-btn-220' + '__' + sanitizedUrl"
                                    [class.active]="activeView === 'basic'" (click)="setView('basic')">Basic
                                    information</button>
                            </div>
                            <!--
                            <div class="details-toolbar">
                                <div class="search-bar">
                                    <i class="icon-search"></i>
                                    <input [attr.guide]="'lead-detail-inp-221' + '__' + sanitizedUrl" type="text" placeholder="Search fields" />
                                </div>
                                 <div class="toggle-switch">
                                    <span>Show empty fields</span>
                                    <label class="switch">
                                        <input [attr.guide]="'lead-detail-inp-222' + '__' + sanitizedUrl" type="checkbox" checked />
                                        <span class="slider round"></span>
                                    </label>
                                </div>
                            </div>
 -->
                            <div class="details-content" [class.basic-view]="activeViewNew === 'basic'">
                                <div class="content-section">
                                    <div class="section-body">
                                        <div class="details-grid-4col">

                                            <div class="info-item"
                                                *ngIf="DealDetailsObject?.dealsName || DealDetailsObject?.dealname">
                                                <label>Deals Name</label>
                                                <div class="value-display">
                                                    <a>{{ DealDetailsObject?.dealsName || DealDetailsObject?.dealname
                                                        }}</a>
                                                    <button
                                                        [attr.guide]="'lead-detail-btn-custom-1' + '__' + sanitizedUrl"
                                                        (click)="openEditPopup('dealsName', 'Deals Name', 'text')"
                                                        class="edit-btn">
                                                        <mat-icon>edit</mat-icon>
                                                    </button>
                                                </div>
                                            </div>

                                            <div class="info-item"
                                                *ngIf="DealDetailsObject?.product && DealDetailsObject?.product !== '-'">
                                                <label>Product</label>
                                                <div class="value-display">
                                                    <a>{{ DealDetailsObject?.product }}</a>
                                                    <button
                                                        [attr.guide]="'lead-detail-btn-custom-2' + '__' + sanitizedUrl"
                                                        (click)="openEditPopup('product', 'Product', 'text')"
                                                        class="edit-btn">
                                                        <mat-icon>edit</mat-icon>
                                                    </button>
                                                </div>
                                            </div>

                                            <div class="info-item"
                                                *ngIf="DealDetailsObject?.amount != null && DealDetailsObject?.amount !== ''">
                                                <label>Amount</label>
                                                <div class="value-display">
                                                    <a>{{ DealDetailsObject?.amount }}</a>
                                                    <button
                                                        [attr.guide]="'lead-detail-btn-custom-3' + '__' + sanitizedUrl"
                                                        (click)="openEditPopup('amount', 'Amount', 'number')"
                                                        class="edit-btn">
                                                        <mat-icon>edit</mat-icon>
                                                    </button>
                                                </div>
                                            </div>

                                            <div class="info-item"
                                                *ngIf="DealDetailsObject?.statusName || DealDetailsObject?.stage">
                                                <label>Stage</label>
                                                <div class="value-display">
                                                    <a>{{ DealDetailsObject?.statusName || DealDetailsObject?.stage
                                                        }}</a>
                                                    <button
                                                        [attr.guide]="'lead-detail-btn-custom-4' + '__' + sanitizedUrl"
                                                        (click)="openEditPopup('statusName', 'Stage', 'select')"
                                                        class="edit-btn">
                                                        <mat-icon>edit</mat-icon>
                                                    </button>
                                                </div>
                                            </div>

                                            <div class="info-item"
                                                *ngIf="DealDetailsObject?.ownerIdName && DealDetailsObject?.ownerIdName !== '-'">
                                                <label>Deals Owner</label>
                                                <div class="value-display">
                                                    <a>{{ (DealDetailsObject?.ownerIdName || '').split('@')[0] |
                                                        titlecase }}</a>
                                                    <button
                                                        [attr.guide]="'lead-detail-btn-custom-5' + '__' + sanitizedUrl"
                                                        (click)="transferLead()" class="edit-btn">
                                                        <mat-icon>edit</mat-icon>
                                                    </button>
                                                </div>
                                            </div>

                                            <div class="info-item" *ngIf="DealDetailsObject?.closingDate">
                                                <label>Closing Date</label>
                                                <div class="value-display">
                                                    <a>{{ DealDetailsObject?.closingDate | date:'mediumDate' }}</a>
                                                    <button
                                                        [attr.guide]="'lead-detail-btn-custom-6' + '__' + sanitizedUrl"
                                                        (click)="openEditPopup('closingDate', 'Closing Date', 'date')"
                                                        class="edit-btn">
                                                        <mat-icon>edit</mat-icon>
                                                    </button>
                                                </div>
                                            </div>

                                            <div class="info-item" *ngIf="DealDetailsObject?.expectedClosingDate">
                                                <label>Expected Closing Date</label>
                                                <div class="value-display">
                                                    <a>{{ DealDetailsObject?.expectedClosingDate | date:'mediumDate'
                                                        }}</a>
                                                    <button
                                                        [attr.guide]="'lead-detail-btn-custom-7' + '__' + sanitizedUrl"
                                                        (click)="openEditPopup('expectedClosingDate', 'Expected Closing Date', 'date')"
                                                        class="edit-btn">
                                                        <mat-icon>edit</mat-icon>
                                                    </button>
                                                </div>
                                            </div>

                                            <div class="info-item" *ngIf="DealDetailsObject?.leadCreatedDate">
                                                <label>Lead Created Date</label>
                                                <div class="value-display">
                                                    <a>{{ DealDetailsObject?.leadCreatedDate | date:'mediumDate' }}</a>
                                                    <button
                                                        [attr.guide]="'lead-detail-btn-custom-8' + '__' + sanitizedUrl"
                                                        (click)="openEditPopup('leadCreatedDate', 'Lead Created Date', 'date')"
                                                        class="edit-btn">
                                                        <mat-icon>edit</mat-icon>
                                                    </button>
                                                </div>
                                            </div>

                                            <div class="info-item"
                                                *ngIf="DealDetailsObject?.name && DealDetailsObject?.name !== '-'">
                                                <label>Lead Name</label>
                                                <div class="value-display">
                                                    <a>{{ (DealDetailsObject?.name?.indexOf(' ') === -1 &&
                                                        DealDetailsObject?.name?.length > 20) ? (DealDetailsObject?.name
                                                        | slice:0:20) + '...' : DealDetailsObject?.name }}</a>
                                                    <button
                                                        [attr.guide]="'lead-detail-btn-custom-9' + '__' + sanitizedUrl"
                                                        (click)="openEditPopup('name', 'Lead Name', 'text')"
                                                        class="edit-btn">
                                                        <mat-icon>edit</mat-icon>
                                                    </button>
                                                </div>
                                            </div>

                                            <div class="info-item"
                                                *ngIf="DealDetailsObject?.company && DealDetailsObject?.company !== '-'">
                                                <label>Company</label>
                                                <div class="value-display">
                                                    <a (click)="goToCompany()">{{ DealDetailsObject?.company }}</a>
                                                    <button
                                                        [attr.guide]="'lead-detail-btn-custom-10' + '__' + sanitizedUrl"
                                                        (click)="openEditPopup('company', 'Company', 'text')"
                                                        class="edit-btn">
                                                        <mat-icon>edit</mat-icon>
                                                    </button>
                                                </div>
                                            </div>

                                            <div class="info-item" *ngIf="DealDetailsObject?.createdDate">
                                                <label>Created Date</label>
                                                <div class="value-display">
                                                    <a>{{ DealDetailsObject?.createdDate | date:'mediumDate' }}</a>
                                                    <button
                                                        [attr.guide]="'lead-detail-btn-custom-11' + '__' + sanitizedUrl"
                                                        (click)="openEditPopup('createdDate', 'Created Date', 'date')"
                                                        class="edit-btn">
                                                        <mat-icon>edit</mat-icon>
                                                    </button>
                                                </div>
                                            </div>

                                            <div class="info-item" *ngIf="DealDetailsObject?.updatedDate">
                                                <label>Updated Date</label>
                                                <div class="value-display">
                                                    <a>{{ DealDetailsObject?.updatedDate | date:'mediumDate' }}</a>
                                                    <button
                                                        [attr.guide]="'lead-detail-btn-custom-12' + '__' + sanitizedUrl"
                                                        (click)="openEditPopup('updatedDate', 'Updated Date', 'date')"
                                                        class="edit-btn">
                                                        <mat-icon>edit</mat-icon>
                                                    </button>
                                                </div>
                                            </div>

                                            <div class="info-item"
                                                *ngIf="DealDetailsObject?.reasonForLoss && DealDetailsObject?.reasonForLoss !== '-'">
                                                <label>Reason For Loss</label>
                                                <div class="value-display">
                                                    <a>{{ DealDetailsObject?.reasonForLoss }}</a>
                                                    <button
                                                        [attr.guide]="'lead-detail-btn-custom-13' + '__' + sanitizedUrl"
                                                        (click)="openEditPopup('reasonForLoss', 'Reason For Loss', 'text')"
                                                        class="edit-btn">
                                                        <mat-icon>edit</mat-icon>
                                                    </button>
                                                </div>
                                            </div>

                                            <div class="info-item" *ngIf="DealDetailsObject?.renewalDate">
                                                <label>Renewal Date</label>
                                                <div class="value-display">
                                                    <a>{{ DealDetailsObject?.renewalDate | date:'mediumDate' }}</a>
                                                    <button
                                                        [attr.guide]="'lead-detail-btn-custom-14' + '__' + sanitizedUrl"
                                                        (click)="openEditPopup('renewalDate', 'Renewal Date', 'date')"
                                                        class="edit-btn">
                                                        <mat-icon>edit</mat-icon>
                                                    </button>
                                                </div>
                                            </div>

                                            <div class="info-item"
                                                *ngIf="DealDetailsObject?.probability != null && DealDetailsObject?.probability !== ''">
                                                <label>Probability</label>
                                                <div class="value-display">
                                                    <a>{{ DealDetailsObject?.probability }}</a>
                                                    <button
                                                        [attr.guide]="'lead-detail-btn-custom-15' + '__' + sanitizedUrl"
                                                        (click)="openEditPopup('probability', 'Probability', 'number')"
                                                        class="edit-btn">
                                                        <mat-icon>edit</mat-icon>
                                                    </button>
                                                </div>
                                            </div>

                                            <div class="info-item"
                                                *ngIf="DealDetailsObject?.paid != null && DealDetailsObject?.paid !== ''">
                                                <label>Paid</label>
                                                <div class="value-display">
                                                    <a>{{ DealDetailsObject?.paid }}</a>
                                                    <button
                                                        [attr.guide]="'lead-detail-btn-custom-16' + '__' + sanitizedUrl"
                                                        (click)="openEditPopup('paid', 'Paid', 'number')"
                                                        class="edit-btn">
                                                        <mat-icon>edit</mat-icon>
                                                    </button>
                                                </div>
                                            </div>

                                            <div class="info-item"
                                                *ngIf="DealDetailsObject?.balance != null && DealDetailsObject?.balance !== ''">
                                                <label>Balance</label>
                                                <div class="value-display">
                                                    <a>{{ DealDetailsObject?.balance }}</a>
                                                    <button
                                                        [attr.guide]="'lead-detail-btn-custom-17' + '__' + sanitizedUrl"
                                                        (click)="openEditPopup('balance', 'Balance', 'number')"
                                                        class="edit-btn">
                                                        <mat-icon>edit</mat-icon>
                                                    </button>
                                                </div>
                                            </div>

                                            <div class="info-item"
                                                *ngIf="DealDetailsObject?.paymentStatus && DealDetailsObject?.paymentStatus !== '-'">
                                                <label>Payment Status</label>
                                                <div class="value-display">
                                                    <a>{{ DealDetailsObject?.paymentStatus }}</a>
                                                    <button
                                                        [attr.guide]="'lead-detail-btn-custom-18' + '__' + sanitizedUrl"
                                                        (click)="openEditPopup('paymentStatus', 'Payment Status', 'select')"
                                                        class="edit-btn">
                                                        <mat-icon>edit</mat-icon>
                                                    </button>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div *ngSwitchCase="'My Views'">
                        <div class="contact-details-container">
                            <div class="details-header">
                                <h2>My Views</h2>
                                <div class="header-actions">
                                    <button [attr.guide]="'lead-detail-btn-256' + '__' + sanitizedUrl"
                                        (click)="manageFields()" class="btn-secondary">Manage fields</button>
                                </div>
                            </div>

                            <div class="details-tabs">
                                <button [attr.guide]="'lead-detail-btn-257' + '__' + sanitizedUrl"
                                    [class.active]="activeViewNew === 'basic'" (click)="setViewNew('basic')">Lead
                                    information</button>
                                <button [attr.guide]="'lead-detail-btn-258' + '__' + sanitizedUrl"
                                    [class.active]="activeViewNew === 'Original'" (click)="setViewNew('Original')">
                                    Original Lead Format</button>

                            </div>

                            <div class="details-content">
                                <div *ngIf="activeViewNew === 'Original'">

                                    <div class="content-section">

                                        <ng-container
                                            *ngIf="jsonRecieved && (jsonRecieved | keyvalue).length > 0; else noRecord">
                                            <div>
                                                <table id="details">
                                                    <tr *ngFor="let item of jsonRecieved | keyvalue">
                                                        <td>
                                                            {{ item.key === 'adGroupName' ? 'Campaign Name' : item.key
                                                            }}
                                                        </td>
                                                        <td>
                                                            <p *ngIf="item.key!='Deal Status' &&item.key!='Lead Source' &&item.key!='Category' &&item.key!='Product'"
                                                                class="blackColor wordBreak" [innerHTML]="item.value">
                                                            </p>

                                                            <p *ngIf="item.key=='Deal Status'"
                                                                class="blackColor wordBreak"
                                                                [innerHTML]="DealDetailsObject?.statusName"> </p>
                                                            <p *ngIf="item.key=='Lead Source'"
                                                                class="blackColor wordBreak"
                                                                [innerHTML]="DealDetailsObject?.sourceName"> </p>
                                                            <p *ngIf="item.key=='Category'" class="blackColor wordBreak"
                                                                [innerHTML]="DealDetailsObject?.category"> </p>
                                                            <p *ngIf="item.key=='Product'" class="blackColor wordBreak"
                                                                [innerHTML]="DealDetailsObject?.product"> </p>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </ng-container>
                                        <ng-template #noRecord>
                                            <div class="text-center text-muted py-4">
                                                <p>No data found.</p>
                                            </div>
                                        </ng-template>

                                    </div>

                                </div>

                                <div *ngIf="activeViewNew === 'basic'">

                                    <div class="content-section" *ngIf="manageFieldCustomization == 0">

                                        <ng-container>
                                            <div>

                                                <table
                                                    *ngIf="leadCommonPropertiesDisplay==1 && usedInSite!=null&&(usedInSite | keyvalue)?.length> 0">

                                                    <tr>
                                                        <th colspan="2">
                                                            {{leadCommonPropertiesName || 'Lead Information'}}
                                                        </th>
                                                    </tr>
                                                    <ng-container *ngIf="!type3">

                                                        <tr *ngFor="let item of usedInSite | keyvalue">
                                                            <td>
                                                                {{item.key}}
                                                            </td>
                                                            <td>
                                                                <p *ngIf="item.key!='Deal Status' &&item.key!='Lead Source' &&item.key!='Category' &&item.key!='Product'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="item.value">
                                                                </p>

                                                                <p *ngIf="item.key=='Deal Status'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="DealDetailsObject?.statusName"> </p>
                                                                <p *ngIf="item.key=='Lead Source'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="DealDetailsObject?.sourceName"> </p>
                                                                <p *ngIf="item.key=='Category'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="DealDetailsObject?.category"> </p>
                                                                <p *ngIf="item.key=='Product'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="DealDetailsObject?.product"> </p>
                                                            </td>
                                                        </tr>

                                                    </ng-container>
                                                    <ng-container *ngIf="type3">

                                                        <tr *ngFor="let item of customList ">


                                                            <td>
                                                                {{item[0]}}
                                                            </td>
                                                            <td>
                                                                <p *ngIf="item[0]!='Deal Status' &&item[0]!='Lead Source'
                                                                 && item[0]!='Lead_Source' &&item[0]!='Lead_Status' && item[0]!='Lead Source' && item[0]!='Category' && item[0]!='Product'"
                                                                    class="blackColor wordBreak" [innerHTML]="item[1]">
                                                                </p>


                                                                <p *ngIf="item[0]=='Deal Status' || item[0]=='Lead_Status'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="DealDetailsObject?.statusName"> </p>
                                                                <p *ngIf="item[0]=='Lead Source' || item[0]=='Lead_Source'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="DealDetailsObject?.sourceName"> </p>
                                                                <p *ngIf="item[0]=='Category'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="DealDetailsObject?.category"> </p>
                                                                <p *ngIf="item[0]=='Product'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="DealDetailsObject?.product"> </p>

                                                            </td>
                                                        </tr>

                                                    </ng-container>
                                                </table>


                                                <table
                                                    *ngIf="leadPropertiesDisplay==1 && filterList!=null&&(filterList | keyvalue)?.length> 0">

                                                    <tr>
                                                        <th colspan="2">
                                                            {{leadPropertiesName || 'Lead Information'}}
                                                        </th>
                                                    </tr>


                                                    <ng-container *ngIf="!type2">

                                                        <tr *ngFor="let item of valuesList | keyvalue">
                                                            <td>
                                                                {{item.key}}
                                                            </td>
                                                            <td>

                                                                <p *ngIf="item.key!='Deal Status' && item.key!='Lead_Source' &&  item.key!='Lead_Status' && item.key!='Lead Source' && item.key!='Category' && item.key!='Product'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="item.value">
                                                                </p>

                                                                <p *ngIf="item.key=='Deal Status' || item.key=='Lead_Status'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="DealDetailsObject?.statusName"> </p>
                                                                <p *ngIf="item.key=='Lead Source' || item.key=='Lead_Source'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="DealDetailsObject?.sourceName"> </p>
                                                                <p *ngIf="item.key=='Category' || item.key=='Category'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="DealDetailsObject?.category"> </p>
                                                                <p *ngIf="item.key=='Product' || item.key=='Product'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="DealDetailsObject?.product"> </p>

                                                            </td>

                                                        </tr>

                                                    </ng-container>
                                                    <ng-container *ngIf="type2">

                                                        <tr *ngFor="let item of filterList | keyvalue">


                                                            <td>
                                                                {{item.key}}
                                                            </td>
                                                            <td>
                                                                <p *ngIf="item.key!='Deal Status' && item.key!='Lead_Source' &&  item.key!='Lead_Status' && item.key!='Lead Source' && item.key!='Category' && item.key!='Product'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="item.value">
                                                                </p>

                                                                <p *ngIf="item.key=='Deal Status' || item.key=='Lead_Status'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="DealDetailsObject?.statusName"> </p>
                                                                <p *ngIf="item.key=='Lead Source' || item.key=='Lead_Source'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="DealDetailsObject?.sourceName"> </p>
                                                                <p *ngIf="item.key=='Category' || item.key=='Category'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="DealDetailsObject?.category"> </p>
                                                                <p *ngIf="item.key=='Product' || item.key=='Product'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="DealDetailsObject?.product"> </p>

                                                            </td>
                                                        </tr>

                                                    </ng-container>

                                                </table>

                                                <!-- spacing between consecutive tables is handled by CSS; removed <br> -->

                                                <table
                                                    *ngIf="leadAdditionalPropertiesDisplay==1 && additionalSpec!=null&&(additionalSpec | keyvalue)?.length> 0">

                                                    <tr>
                                                        <th colspan="2">
                                                            {{leadAdditionalPropertiesName || 'Lead Additional
                                                            Information'}}
                                                        </th>
                                                    </tr>


                                                    <ng-container *ngIf="!type1">

                                                        <tr *ngFor="let item of additionalSpec | keyvalue">
                                                            <td>
                                                                {{item.key}}
                                                            </td>
                                                            <td>
                                                                <p *ngIf="item.key!='Deal Status' && item.key!='Lead_Source' &&  item.key!='Lead_Status' && item.key!='Lead Source' && item.key!='Category' && item.key!='Product'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="item.value">
                                                                </p>

                                                                <p *ngIf="item.key=='Deal Status' || item.key=='Lead_Status'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="DealDetailsObject?.statusName"> </p>
                                                                <p *ngIf="item.key=='Lead Source' || item.key=='Lead_Source'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="DealDetailsObject?.sourceName"> </p>
                                                                <p *ngIf="item.key=='Category' || item.key=='Category'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="DealDetailsObject?.category"> </p>
                                                                <p *ngIf="item.key=='Product' || item.key=='Product'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="DealDetailsObject?.product"> </p>

                                                            </td>
                                                        </tr>

                                                    </ng-container>

                                                    <ng-container *ngIf="type1">


                                                        <tr *ngFor="let item of additionalSpecList">
                                                            <td>{{ item[0] }}</td>
                                                            <td>

                                                                <ng-container [ngSwitch]="item[0]">

                                                                    <p *ngSwitchCase="'Deal Status'"
                                                                        class="blackColor wordBreak">
                                                                        {{ DealDetailsObject?.statusName }}
                                                                    </p>

                                                                    <p *ngSwitchCase="'Lead_Status'"
                                                                        class="blackColor wordBreak">
                                                                        {{ DealDetailsObject?.statusName }}
                                                                    </p>

                                                                    <p *ngSwitchCase="'Lead Source'"
                                                                        class="blackColor wordBreak">
                                                                        {{ DealDetailsObject?.sourceName }}
                                                                    </p>

                                                                    <p *ngSwitchCase="'Lead_Source'"
                                                                        class="blackColor wordBreak">
                                                                        {{ DealDetailsObject?.sourceName }}
                                                                    </p>

                                                                    <p *ngSwitchCase="'Category'"
                                                                        class="blackColor wordBreak">
                                                                        {{ DealDetailsObject?.category }}
                                                                    </p>

                                                                    <p *ngSwitchCase="'Product'"
                                                                        class="blackColor wordBreak">
                                                                        {{ DealDetailsObject?.product }}
                                                                    </p>

                                                                    <p *ngSwitchDefault class="blackColor wordBreak">
                                                                        {{ item[1] }}
                                                                    </p>

                                                                </ng-container>

                                                            </td>
                                                        </tr>


                                                    </ng-container>


                                                </table>

                                            </div>
                                        </ng-container>
                                        <ng-template #noRecord>
                                            <div class="text-center text-muted py-4">
                                                <p>No data found.</p>
                                            </div>
                                        </ng-template>

                                    </div>

                                    <div class="content-section" *ngIf="manageFieldCustomization == 1">



                                        <ng-container *ngIf="mappedGroups?.length > 0; else noData">

                                            <div class="content-section" *ngFor="let group of mappedGroups">
                                                <div class="section-header">
                                                    <h3>{{ group.groupName }}</h3>
                                                </div>

                                                <div class="section-body">
                                                    <div class="details-grid-4col">

                                                        <div class="info-item" *ngFor="let field of group.fields">

                                                            <label>{{ field.fieldName }}</label>

                                                            <div class="value-display">
                                                                <ng-container [ngSwitch]="field.fieldKey">

                                                                    <a [attr.guide]="'lead-detail-lnk-259' + '__' + sanitizedUrl"
                                                                        *ngSwitchCase="'Email'"
                                                                        (click)="field.value !== '-' ? openEmailPopup() : null">
                                                                        {{ field.value }}
                                                                    </a>

                                                                    <span *ngSwitchDefault>
                                                                        {{ field.value }}
                                                                    </span>

                                                                </ng-container>

                                                                <button
                                                                    [attr.guide]="'lead-detail-btn-260' + '__' + sanitizedUrl"
                                                                    *ngIf="!field.isReadOnly"
                                                                    (click)="openEditPopupNew(field.fieldKey, field.fieldName, field.fieldType, field)"
                                                                    class="edit-btn">
                                                                    <mat-icon>edit</mat-icon>
                                                                </button>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>

                                        </ng-container>

                                        <ng-template #noData>
                                            <div fxLayoutAlign="center center" class="text-center text-muted py-4">
                                                No data available
                                            </div>
                                        </ng-template>



                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- <div *ngSwitchCase="'Conversations'">
                        <div class="card">
                            <div *ngIf="leadLoaded">
                                <calsoft-whatsapp-chat-details [contactId]="DealDetailsObject?.phoneNumber"
                                    [isFromPhone]="true"></calsoft-whatsapp-chat-details>
                            </div>
                        </div>

                    </div> -->


                    <div>


                        <div *ngSwitchCase="'Activities'">
                            <div>
                                <div class="card activities-new-type">
                                    <div class="activity-container">


                                        <!-- <div class="filters">
                                    <span>Filter by:</span>
                                    <button [attr.guide]="'lead-detail-btn-262' + '__' + sanitizedUrl" class="filter-btn">All activities ---</button>
                                    <button [attr.guide]="'lead-detail-btn-263' + '__' + sanitizedUrl" class="filter-btn">All time periods ---</button>
                                </div> -->
                                        <div style="overflow-x: auto;">
                                            <div *ngIf="activityHistoryType == 0 || !activityHistoryType"
                                                class="timeline">
                                                <calsoft-activity-new [type]="1" [spinner]="spinner"
                                                    [onScrollValue]="onScrollValue"
                                                    [groupedActivities]="groupedActivities"
                                                    (scrollChange)="onScrollNew()"></calsoft-activity-new>
                                            </div>
                                            <ng-container *ngIf="activityHistoryType == 1">
                                                <calsoft-activity (scrollChange)="onScroll()" [spinner]="spinner"
                                                    [onScrollValue]="onScrollValue"
                                                    [leadActivityListFinal]="leadActivityListFinal"
                                                    [totalSize]="totalSize" [leadid]="leadId" fxFlex
                                                    [leadActivityList]="leadActivityList">
                                                </calsoft-activity>
                                            </ng-container>

                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div *ngSwitchCase="'Leads'">
                        <div class="deals-table-container"
                            style="background: #ffffff; border-radius: 8px; border: 1px solid #e2e8f0; padding: 16px; margin-bottom: 20px; overflow-x: auto;">
                            <table style="width: 100%; border-collapse: collapse; text-align: left;">
                                <thead>
                                    <tr style="background-color: #f8fafc; border-bottom: 1px solid #e2e8f0;">
                                        <th
                                            style="padding: 12px 16px; font-size: 13px; font-weight: 600; color: #475569;">
                                            Lead Name</th>
                                        <th
                                            style="padding: 12px 16px; font-size: 13px; font-weight: 600; color: #475569;">
                                            Phone</th>
                                        <th
                                            style="padding: 12px 16px; font-size: 13px; font-weight: 600; color: #475569;">
                                            Owner</th>
                                        <th
                                            style="padding: 12px 16px; font-size: 13px; font-weight: 600; color: #475569;">
                                            Lead Status</th>
                                        <th
                                            style="padding: 12px 16px; font-size: 13px; font-weight: 600; color: #475569;">
                                            Lead Source</th>
                                        <th
                                            style="padding: 12px 16px; font-size: 13px; font-weight: 600; color: #475569;">
                                            Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let lead of leadList" style="border-bottom: 1px solid #f1f5f9;">
                                        <td
                                            style="padding: 12px 16px; font-size: 13px; color: #334155; font-weight: 500;">
                                            {{lead?.name || '--' }}
                                        </td>
                                        <td style="padding: 12px 16px; font-size: 13px; color: #334155;">
                                            {{ lead?.phoneNumber || '--' }}
                                        </td>
                                        <td style="padding: 12px 16px; font-size: 13px; color: #334155;">
                                            {{lead?.ownerName || '--' }}
                                        </td>
                                        <td style="padding: 12px 16px; font-size: 13px; color: #334155;">
                                            {{ lead?.statusName || '--' }}
                                        </td>
                                        <td style="padding: 12px 16px; font-size: 13px; color: #334155;">
                                            {{ lead?.sourceName || '-' }}
                                        </td>
                                        <td style="padding: 12px 16px; font-size: 13px; color: #334155;">
                                            <button [attr.guide]="'lead-detail-btn-deals-action' + '__' + sanitizedUrl"
                                                style="border: none; background: transparent; cursor: pointer; color: #1976d2; padding: 0;"
                                                [matMenuTriggerFor]="dealsTabActionMenu">
                                                <mat-icon style="font-size: 20px;">more_vert</mat-icon>
                                            </button>
                                            <mat-menu #dealsTabActionMenu="matMenu">
                                                <button mat-menu-item (click)="editLead(lead.entityId)">
                                                    <mat-icon>edit</mat-icon> Edit
                                                </button>
                                            </mat-menu>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <!-- <div class="width-table">
                            <div class="deal-page1">
                                <calsoft-deal-table [type]="2" [dealsPrimaryType]="0" [DealType]="2"
                                    [data]="DealDetailsObject" [defaultSet]="defaultSet"
                                    [defaultSetType]="defaultSetType" [leadId]="leadId"
                                    [dealsTableView]="1"></calsoft-deal-table>
                            </div>
                        </div> -->
                    </div>


                </div>
            </div>

        </div>
    </div>
</div>